import { useTranslation } from "react-i18next"
import clsx from "clsx"
import { useState } from "react"

export const HistoryComponent = () => {
  const { t } = useTranslation("History")

  const [ selectedIndex, setSelectedIndex ] = useState<number>(0)

  const items = [
    { year: 2002, title: t("Rozpoczęcie działalności firmy"), description: t("Rozpoczęcie działalności firmy.Description") },
    { year: 2005, title: t("Wprowadzenie do oferty systemów drzwiowych"), description: t("Wprowadzenie do oferty systemów drzwiowych.Description") },
    { year: 2007, title: t("Przeprowadzka do nowej siedziby"), description: t("Przeprowadzka do nowej siedziby.Description") },
    { year: 2008, title: t("Wprowadzenie do oferty Systemu Kreator"), description: t("Wprowadzenie do oferty Systemu Kreator.Description") },
    { year: 2010, title: t("Udostępnienie stolarzom programu Aluprofil Visual"), description: t("Udostępnienie stolarzom programu Aluprofil Visual.Description") },
    { year: 2011, title: t("Wprowadzenie do oferty akcesoriów meblowych"), description: t("Wprowadzenie do oferty akcesoriów meblowych.Description") },
    { year: 2013, title: t("Wprowadzenie do oferty linii Medium 56 i Exclusive 82"), description: t("Wprowadzenie do oferty linii Medium 56 i Exclusive 82.Description") },
    { year: 2014, title: t("Wprowadzenie do oferty złączy meblowych"), description: t("Wprowadzenie do oferty złączy meblowych.Description") },
    { year: 2015, title: t("Udostępnienie stolarzom programu Aluprofil Olimp"), description: t("Udostępnienie stolarzom programu Aluprofil Olimp.Description") },
    { year: 2017, title: t("Uruchomienie nowego parku maszynowego"), description: t("Uruchomienie nowego parku maszynowego.Description") },
    { year: 2018, title: t("Odświeżenie identyfikacji wizualnej firmy"), description: t("Odświeżenie identyfikacji wizualnej firmy.Description") },
    { year: 2019, title: t("Udostępnienie stolarzom drzwiprzesuwne.pl"), description: t("Udostępnienie stolarzom drzwiprzesuwne.pl.Description") },
    { year: 2022, title: t("Dwudziestolecie działalności firmy"), description: t("Dwudziestolecie działalności firmy.Description") },
    { year: 2024, title: t("Zmiany w ofercie Systemu Kreator"), description: t("Zmiany w ofercie Systemu Kreator.Description") },
  ]

  return (
    <div className="w-full bg-white">
      <div className="mx-auto container">
        <div className="px-4 py-16">
          <hr className="mb-16 border-t-2 border-aluprofil-gray/20" />

          <h2 className="mb-16 w-full font-head font-normal text-5xl text-aluprofil-gray">
            {t("Historia działalności")}
          </h2>

          <div className="flex flex-col gap-y-16 items-center">
            <ul className="w-full flex flex-row lg:justify-center overflow-auto">
              {items.map(
                  (item, index) => (
                    <li key={item.year} className="flex flex-col">
                      <a className="block px-3 text-aluprofil-gray/80" href="#"
                        onClick={
                          (e) => {
                            e.preventDefault()

                            setSelectedIndex(index)
                          }
                        }
                      >
                        {item.year}
                      </a>

                      <span className="w-full grid grid-cols-alt-3 items-center">
                        {index !== 0 ? (
                          <span className="col-start-1 block h-0.5 bg-aluprofil-gray" />
                        ) : null}

                        <span className="col-start-2 block">
                          <a className="flex size-4 items-center justify-center bg-aluprofil-gray/20 rounded-full" href="#"
                            onClick={
                              (e) => {
                                e.preventDefault()

                                setSelectedIndex(index)
                              }
                            }
                          >
                            <span
                              className={
                                clsx(
                                  "block size-3 rounded-full", index === selectedIndex ? "bg-aluprofil-red" : "bg-aluprofil-gray"
                                )
                              }
                            />
                          </a>
                        </span>

                        <span className="col-start-3 block h-0.5 bg-aluprofil-gray" />
                      </span>
                    </li>
                  )
                )
              }
            </ul>

            {items.map(
                (item, index) => index === selectedIndex ? (
                  <div key={index} className="flex flex-col gap-4 md:w-1/2">
                    <div className="font-head font-bold text-2xl text-aluprofil-gray">
                      {item.title}
                    </div>

                    <div className="text-base text-aluprofil-gray">
                      {item.description}
                    </div>
                  </div>
                ) : null
              )
            }
          </div>
        </div>
      </div>
    </div>
  )
}
